module.exports = __webpack_public_path__ + "static/media/Richard_natter.3bfd772b.jpg";